var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.markers),function(marker,index){return _c('CloMapGoogleMarker',{key:index,attrs:{"marker":marker,"content":marker.content,"google":_vm.google,"map":_vm.map},on:{"marker-click":_vm.markerClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }